import { Home, Settings, File, GitBranch, Book, TrendingUp, Users, Package,FileText,CreditCard, ShoppingBag, Archive,Clipboard } from 'react-feather'
export const MENUITEMS = [
  {
    menutitle: "",
    menucontent: "",
    Items: [
      { path: `/dashboard/default`, icon: Home, title: 'Tableau de bord', active: false, type: 'link' },
      { path: `/visites/rapports`, icon: File, title: 'Rapports Visites', active: false, type: 'link' },
      { path: `/focus/rapports`, icon: FileText, title: 'Rapports Focus', active: false, type: 'link' },
    
      {
        title: 'Tournée', icon: GitBranch, type: 'sub', active: false, children: [
          { path: `/tournee/valides`, title: 'Validés', type: 'link' },
          { path: `/tournee/enattente`, title: 'En attente', type: 'link' },
        ]
      },
      { path: `/bdc`, icon: CreditCard, title: 'Bons de commandes', active: false, type: 'link' },
      { path: `/grossiste/list`, icon: ShoppingBag, title: "Grosistes", active: false, type: 'link' },
      { path: `/contacts`, icon: Book, title: 'Contacts', active: false, type: 'link' },
      { path: `/users`, icon: Users, title: 'Utilisateurs', active: false, type: 'link' },
      { path: `/visitesDuo/rapports`, icon: Archive, title: 'Fiches DUO', active: false, type: 'link' },
      { path: `/syntheses/liste`, icon: Clipboard, title: 'Synthèses', active: false, type: 'link' },
      { path: `/products`, icon: Package, title: 'Produits', active: false, type: 'link' },
      {
        title: 'Statistiques', icon: TrendingUp, type: 'sub', active: false, children: [
          { path: `/stats/agents`, title: 'Statistiques visiteurs', type: 'link' },
          { path: `/stats/products`, title: 'Staitistiques produits', type: 'link' },
        ]
      },
      { path: `/settings`, icon: Settings, title: 'Paramétres', active: false, type: 'link' },
    ]
  },
]